<template>
  <div class="uk-user-registration-warning" v-html="$t('authentication-app.uk-authorization-warning')"></div>
</template>

<script>
export default {
  name: 'UkWarningMessage',
}
</script>

<style lang="scss">
.uk-user-registration-warning {
  text-align: center;

  strong {
    font-family: $font-bold;
  }
}
</style>
